module.exports = __webpack_public_path__ + "static/fonts/ibm-plex-mono-v12-latin-500italic.7d62483.woff";